<template>
    <div>
        <v-list>
            <component-wrapper v-for="(card,index) in cards" :key="index" :config="card" />
        </v-list>
    </div>
</template>

<script>
export default {
    name: 'zoezi-product-list',

    zoezi: {
        title: 'Product list',
        icon: 'mdi-format-list-text'
    },

    props: {
        cards: {
            title: 'Product cards',
            type: Array,
            fulltype: 'componentlist',
            typeinfo: {
                component: 'zoezi-product-card'
            },
            default: () => []
        },
        cardHeight: {
            title: 'Card height (px)',
            type: Number,
            default: 200
        }
    }
}
</script>
